(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations-list"]) return;
  try {
    
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(productRecommendationsSection);

      const url = productRecommendationsSection.dataset.url;

      fetch(url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.product-recommendations-list');

          if (recommendations && recommendations.innerHTML.trim().length) {
            productRecommendationsSection.innerHTML = recommendations.innerHTML;
          }
        })
        .catch(e => {
          console.error(e);
        });
    };

    const productRecommendationsSection = document.querySelector('.product-recommendations-list');
    const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

    observer.observe(productRecommendationsSection);
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    
(function() {
  function initCopyBtns(wrap) {
    wrap.querySelectorAll('.pr-promo-item-btn--copy').forEach(function(btn) {
      if (btn._copyInited) return;
      btn._copyInited = true;
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var code = btn.dataset.copy;
        if (!code) return;
        var orig = btn.textContent;
        function onCopied() {
          btn.textContent = 'Copied!';
          btn.classList.add('is-copied');
          setTimeout(function() { btn.textContent = orig; btn.classList.remove('is-copied'); }, 2000);
        }
        function fallback() {
          var ta = document.createElement('textarea');
          ta.value = code;
          ta.style.cssText = 'position:fixed;opacity:0;pointer-events:none';
          document.body.appendChild(ta);
          ta.select();
          try { document.execCommand('copy'); onCopied(); } catch(err) {}
          document.body.removeChild(ta);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(onCopied).catch(fallback);
        } else {
          fallback();
        }
      });
    });
  }
  function initPromoBar() {
    document.querySelectorAll('.pr-promo-wrap').forEach(function(wrap) {
      if (wrap._promoInited) return;
      wrap._promoInited = true;
      var bar = wrap.querySelector('.pr-promo-bar');
      var detail = wrap.querySelector('.pr-promo-detail');
      if (!bar || !detail) return;
      var overlay = detail.querySelector('.pr-promo-detail__overlay');
      var panel = detail.querySelector('.pr-promo-detail__panel');
      var closeBtn = panel ? panel.querySelector('.pr-promo-detail__close') : null;

      // Mobile only: teleport overlay & panel to body to escape theiaStickySidebar
      // transform which confines position:fixed children to its stacking context.
      // Desktop: keep in DOM so the panel is position:absolute relative to .pr-promo-wrap
      // and scrolls naturally with the page.
      var _mobile = window.innerWidth < 768;
      if (_mobile) {
        if (overlay) document.body.appendChild(overlay);
        if (panel) document.body.appendChild(panel);
      }
      if (panel) initCopyBtns(panel);

      function open() {
        detail.classList.add('is-open');
        if (overlay) overlay.classList.add('is-open');
        if (panel) panel.classList.add('is-open');
        if (_mobile) document.body.style.overflow = 'hidden';
      }
      function close() {
        detail.classList.remove('is-open');
        if (overlay) overlay.classList.remove('is-open');
        if (panel) panel.classList.remove('is-open');
        if (_mobile) document.body.style.overflow = '';
      }

      if (panel) { panel._promoBar = bar; panel._promoClose = close; }

      bar.addEventListener('click', function(e) {
        e.stopPropagation();
        detail.classList.contains('is-open') ? close() : open();
      });
      if (overlay) overlay.addEventListener('click', close);
      if (closeBtn) closeBtn.addEventListener('click', function(e) { e.stopPropagation(); close(); });
    });
  }
  document.addEventListener('click', function(e) {
    document.querySelectorAll('.pr-promo-detail__panel.is-open').forEach(function(panel) {
      var bar = panel._promoBar;
      if (panel.contains(e.target)) return;
      if (bar && bar.contains(e.target)) return;
      if (panel._promoClose) panel._promoClose();
    });
  });
  function updateTagsFade() {
    document.querySelectorAll('.pr-promo-tags').forEach(function(tags) {
      if (window.innerWidth >= 768) { tags.classList.remove('is-multirow'); return; }
      var items = tags.querySelectorAll('.pr-promo-tag');
      var multirow = false;
      if (items.length > 1) {
        var firstTop = items[0].getBoundingClientRect().top;
        for (var i = 1; i < items.length; i++) {
          if (items[i].getBoundingClientRect().top > firstTop + 2) { multirow = true; break; }
        }
      }
      tags.classList.toggle('is-multirow', multirow);
    });
  }
  var DAY_MS = 24 * 60 * 60 * 1000;
  var HOUR_MS = 60 * 60 * 1000;
  function fmtHMS(ms) {
    var s = Math.max(0, Math.floor(ms / 1000));
    var hh = Math.floor(s / 3600); s -= hh * 3600;
    var mm = Math.floor(s / 60); s -= mm * 60;
    function p(n) { return (n < 10 ? '0' : '') + n; }
    return p(hh) + ':' + p(mm) + ':' + p(s);
  }
  function tickCountdowns() {
    var now = Date.now();
    document.querySelectorAll('[data-countdown-deadline]').forEach(function(el) {
      var deadline = parseInt(el.dataset.countdownDeadline, 10) * 1000;
      if (!deadline) return;
      var remain = deadline - now;
      var mode = el.dataset.countdownMode;
      if (mode === 'always') {
        var timeEl = el.querySelector('.pr-promo-cd-time');
        if (timeEl) timeEl.textContent = fmtHMS(remain);
        el.classList.toggle('is-urgent', remain > 0 && remain <= HOUR_MS);
        return;
      }
      var inLast24h = remain > 0 && remain <= DAY_MS;
      if (el.dataset.countdownTarget === 'swap') {
        var staticEl = el.querySelector('.pr-promo-date-static');
        var cdEl = el.querySelector('.pr-promo-date-cd');
        if (remain <= 0) {
          el.hidden = true;
        } else if (inLast24h) {
          if (staticEl) staticEl.hidden = true;
          if (cdEl) {
            cdEl.hidden = false;
            cdEl.classList.toggle('is-urgent', remain <= HOUR_MS);
            var t = cdEl.querySelector('.pr-promo-cd-time');
            if (t) t.textContent = fmtHMS(remain);
          }
        } else {
          if (staticEl) staticEl.hidden = false;
          if (cdEl) cdEl.hidden = true;
        }
      } else {
        if (remain <= 0) { el.hidden = true; return; }
        el.hidden = !inLast24h;
        if (inLast24h) {
          el.classList.toggle('is-urgent', remain <= HOUR_MS);
          var timeEl2 = el.querySelector('.pr-promo-cd-time');
          if (timeEl2) timeEl2.textContent = fmtHMS(remain);
        }
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initPromoBar(); updateTagsFade(); tickCountdowns(); });
  } else {
    initPromoBar();
    updateTagsFade();
    tickCountdowns();
  }
  setInterval(tickCountdowns, 1000);
  var _resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(_resizeTimer);
    _resizeTimer = setTimeout(updateTagsFade, 100);
  });
})();

(function() {
  // localStorage keys
  var NC_ACTIVE = 'nc_promo_active'; // '1' = session exists
  var NC_CYCLE  = 'nc_promo_cycle';  // 当前 24h 轮次的起始时间戳
  var NC_EXP    = 'nc_promo_expire'; // 整体到期时间戳（首次进入 + N 天）
  var DAY_MS    = 86400000;

  function initNcPromo() {
    var ncTagEl = document.querySelector('.js-nc-promo-tag');
    if (!ncTagEl) return;

    // ── 1. 检查 localStorage 引荐记录（由全局脚本在首次 utm_nc=1 访问时写入）──
    if (localStorage.getItem(NC_ACTIVE) !== '1') {
      var w = document.querySelector('.js-nc-promo-only');
      if (w) w.hidden = true;
      return;
    }

    // ── 2. 整体有效期检查：到期则清除记录并退出（不再显示）──
    var expireAt = parseInt(localStorage.getItem(NC_EXP), 10) || 0;
    if (expireAt && Date.now() >= expireAt) {
      [NC_ACTIVE, NC_CYCLE, NC_EXP].forEach(function(k) { localStorage.removeItem(k); });
      var w2 = document.querySelector('.js-nc-promo-only');
      if (w2) w2.hidden = true;
      return;
    }

    // ── 3. 显示 Tag 和活动条目 ──
    var ncItem = document.querySelector('.js-nc-promo-item');
    ncTagEl.hidden = false;
    if (ncItem) ncItem.hidden = false;

    // ── 4. 计算当前 24h 轮次的截止时间（每次都从 localStorage 现读，不用闭包变量）──
    function getCycleDeadline() {
      var start = parseInt(localStorage.getItem(NC_CYCLE), 10);
      if (!start) {
        start = Date.now();
        localStorage.setItem(NC_CYCLE, String(start));
      }
      var deadline = start + DAY_MS;
      // 本轮已到期 → 以当前时间开启新一轮
      if (Date.now() >= deadline) {
        start = Date.now();
        localStorage.setItem(NC_CYCLE, String(start));
        deadline = start + DAY_MS;
      }
      return deadline;
    }

    // ── 5. 每秒刷新倒计时显示 ──
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tickNC() {
      var el = document.querySelector('.js-nc-promo-countdown');
      if (!el) return;
      var remain = Math.max(0, getCycleDeadline() - Date.now());
      var s  = Math.floor(remain / 1000);
      var hh = Math.floor(s / 3600); s -= hh * 3600;
      var mm = Math.floor(s / 60);   s -= mm * 60;
      var t = el.querySelector('.pr-promo-cd-time');
      if (t) t.textContent = pad(hh) + ':' + pad(mm) + ':' + pad(s);
      el.classList.toggle('is-urgent', remain > 0 && remain <= 3600000);
    }
    tickNC();
    setInterval(tickNC, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNcPromo);
  } else {
    initNcPromo();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
